export default __webpack_public_path__ + "media/wallpaper/one_thumbnail_large-76387ecb.jpg";